import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { Text, Button, TextInput } from 'react-orange-ui';

import TitleWithCard from '../../Title/TitleWithCard';
import LetterConfirm from './LetterConfirm';

import WordingService from '../../../services/WordingService';
import TagService from '../../../services/TagService';

class LetterView extends Component {
  state = {
    postalCode: '',
  };

  /**
   * Change postalCode state on change
   * Clear any error when exists on change
   * @param postalCode
   */
  handleChange = (postalCode) => {
    const { clearPostalCodeError, postalCodeError } = this.props;

    this.setState({ postalCode });

    if (postalCode && !postalCodeError.valid) {
      clearPostalCodeError();
    }
  };

  /**
   * Send letter on submit
   * @param e
   */
  handleSubmit = (e) => {
    e.preventDefault();

    const { sendLetter, setPostalCodeError } = this.props;
    const { postalCode } = this.state;

    // Send GA event
    TagService.sendAction('sendLetter');

    if (!postalCode) {
      setPostalCodeError('empty');
    } else {
      sendLetter(postalCode);
    }
  };

  render() {
    const { postalCode } = this.state;
    const {
      isFetching,
      letterIsSent,
      postalCodeError,
      quitApp,
    } = this.props;

    if (letterIsSent) {
      return <LetterConfirm quitApp={quitApp} />;
    }
    return (
      <div>
        <Text id="letter-message">
          { WordingService.getWording('caption', 'fillPostalCode') }
        </Text>
        <br />
        <Row>
          <Col xs={12} sm={4}>
            <div>
              <TextInput
                id="postal-code-input"
                size="m"
                maxLength={2}
                onChange={this.handleChange}
                errorMessage={postalCodeError.errorMessage}
                value={postalCode}
                valid={postalCodeError.valid}
              >
                <TitleWithCard
                  idLabel="postal-code-label"
                  idIcon="postal-code-help-icon"
                  title={WordingService.getWording('caption', 'fillTwoDigitsPostalCode')}
                  hint={WordingService.getWording('caption', 'letterIndications')}
                  onIconClick={() => TagService.sendAction('helpPostalCode')}
                />
              </TextInput>
              <br />
              <Button id="submit-postal-code" type="important" onClick={this.handleSubmit} disabled={isFetching}>
                { WordingService.getWording('button', 'validate') }
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

LetterView.defaultProps = {
  isFetching: false,
  postalCodeError: {
    valid: true,
    errorMessage: '',
  },
};

LetterView.propTypes = {
  /** Function to set postal code error */
  setPostalCodeError: PropTypes.func.isRequired,
  /** Action to clear the postal code error received by server */
  clearPostalCodeError: PropTypes.func.isRequired,
  /** Action to send a letter */
  sendLetter: PropTypes.func.isRequired,
  /** Boolean data fetching */
  isFetching: PropTypes.bool,
  /** Boolean when the letter was successfully sent */
  letterIsSent: PropTypes.bool.isRequired,
  /** Action to quit the app */
  quitApp: PropTypes.func.isRequired,
  /** Object postal code error */
  postalCodeError: PropTypes.shape({
    valid: PropTypes.bool,
    errorMessage: PropTypes.string,
  }),
};

export default LetterView;
